import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/api/client';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Client errors will not fix themselves on a retry.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          // Nor will maintenance: the layouts already know (the API client
          // told them), and hammering a platform mid-upgrade helps nobody.
          if (error instanceof ApiError && error.code === 'MAINTENANCE') return false;
          return failureCount < 2;
        },
      },
    },
  });
}
